<div class="track" [class.hidden]="!loading()">
    <div class="bar bar1"></div>
    <div class="bar bar2"></div>
</div>